import {gql} from '@apollo/client';

export const GET_TEAM_AGENT_PERFORMANCE_STATISTICS = gql`
  query GetTeamAgentPerformanceStatistics($filter: AgentPerformanceFilter!) {
    getTeamAgentPerformanceStatistics(filter: $filter) {
      ... on Error {
        statusCode
        message
      }
      ... on ResponseWithAgentPerformanceStatistics {
        data {
          totalAmountDeposited {
            amount
            currency
          }
          totalAmountInvested {
            amount
            currency
          }
          totalDabaProSubscription {
            type
            total
            breakDown {
              currency
              total
            }
          }
          totalTransactionVolume {
            amount
            currency
          }
          settledTransactionByAssetClass {
            currency
            fees {
              variableFee
              totalFee
              staticFee
              fixedFee
            }
            volume
            count
            assetClass
          }
          totalSettledTransactionVolume {
            currency
            amount
          }
          totalDabaAcademySubscription {
            count
            currency
          }
          totalSimulatorTransactions {
            type
            total
            breakDown {
              amount
              currency
              count
            }
          }
        }
      }
    }
  }
`;

export const GET_ADMIN_AGENT_PERFORMANCE_STATISTICS = gql`
  query GetAdminAgentPerformanceStatistics($filter: AgentPerformanceFilter!) {
    getAdminAgentPerformanceStatistics(filter: $filter) {
      ... on Error {
        statusCode
        message
      }
      ... on ResponseWithAgentPerformanceStatistics {
        data {
          totalAmountDeposited {
            amount
            currency
          }
          totalAmountInvested {
            amount
            currency
          }
          totalDabaProSubscription {
            type
            total
            breakDown {
              currency
              total
            }
          }
          totalTransactionVolume {
            amount
            currency
          }
          settledTransactionByAssetClass {
            assetClass
            currency
            fees {
              variableFee
              totalFee
              staticFee
              fixedFee
            }
          }
          totalSettledTransactionVolume {
            currency
            amount
          }
          totalDabaAcademySubscription {
            amount
            currency
          }
          totalSimulatorTransactions {
            type
            total
            breakDown {
              amount
              currency
              count
            }
          }
        }
      }
    }
  }
`;

export const GET_TEAM_AGENT_PERFORMANCE_TRANSACTION_HISTORY = gql`
  query GetTeamAgentPerformanceTransactionHistory(
    $filter: AgentPerformanceFilter!
  ) {
    getTeamAgentPerformanceTransactionHistory(filter: $filter) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWalletTransactions {
        pagination {
          total
        }
        data {
          createdAt
          currency
          locked
          direction
          id
          referenceId
          paymentMetadata
          paymentGateway
          claimedTransaction {
            id
            createdAt
            createdBy {
              email
            }
          }
          paymentProvider
          type
          status
          totalTransactionAmountIncludingFees
          transactionAmountNetOfFees
          transactionFee
          updatedAt
          user {
            id
            firstName
            lastName
            username
            regionCategory {
              region
              subRegion
            }
          }
        }
      }
    }
  }
`;

export const GET_ADMIN_AGENT_PERFORMANCE_TRANSACTION_HISTORY = gql`
  query GetAdminAgentPerformanceTransactionHistory(
    $filter: AgentPerformanceFilter!
  ) {
    getAdminAgentPerformanceTransactionHistory(filter: $filter) {
      ... on Error {
        statusCode
        message
      }
      ... on ResponseWalletTransactions {
        pagination {
          total
        }
        data {
          createdAt
          currency
          locked
          direction
          id
          referenceId
          paymentMetadata
          paymentGateway
          claimedTransaction {
            id
            createdAt
            createdBy {
              email
            }
          }
          paymentProvider
          type
          status
          totalTransactionAmountIncludingFees
          transactionAmountNetOfFees
          transactionFee
          updatedAt
          user {
            id
            firstName
            lastName
            username
            regionCategory {
              region
              subRegion
            }
          }
        }
      }
    }
  }
`;
